// WW-CUSTOM: show the Klaviyo back-in-stock trigger only while the selected variant is sold out.
document.addEventListener('on:variant:change', (event) => {
  const form = event.detail?.form || event.target;
  const trigger = form?.querySelector?.('.ww-bis-trigger') || event.target.querySelector?.('.ww-bis-trigger');
  if (!trigger) return;
  const variant = event.detail?.variant;
  trigger.hidden = !variant || variant.available;
});
